import SmsSimulatorPersonasModal from "containers/sms-simulator/sms-simulator-personas/components/persona-modal/sms-simulator-personas-modal";

import { useUpdatePersona } from "hooks/api/use-sms-simulator-personas";

import {
  EditPersonaProps,
  SmsSimulatorPersonaRequest,
} from "containers/sms-simulator/sms-simulator-personas/sms-simulator-personas.types";

const SmsSimulatorEditPersona = ({ setIsEditPersonaModalOpen, persona }: EditPersonaProps) => {
  const updatePersona = useUpdatePersona();

  const handleEditPersona = async (data: SmsSimulatorPersonaRequest) => {
    try {
      await updatePersona.mutateAsync({ id: persona.id, request: data });
      setIsEditPersonaModalOpen(false);
    } catch {
      // Error toast handled in the mutation.
    }
  };

  return (
    <SmsSimulatorPersonasModal
      onCloseCallback={() => setIsEditPersonaModalOpen(false)}
      onConfirmCallback={handleEditPersona}
      title="Edit persona details"
      defaultValues={{
        name: persona.name,
        grade: persona.grade,
        profileType: persona.profileType,
        interests: persona.interests,
      }}
    />
  );
};

export default SmsSimulatorEditPersona;
